import angular from 'angular';
import navBarService from './navBarService.service';

let navBarServiceModule = angular.module('navBarService', []).service('navBarService', navBarService);

export default navBarServiceModule;



// WEBPACK FOOTER //
// ./app/common/navBarService/navBarService.js